<template>
  <v-card color="blue-grey" class="white--text" >  

    <v-snackbar v-model="snackbar" top color="success">
      {{ snackbarText}}
      <v-btn flat dark @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>  

    <v-card-title primary-title>
      <div>
        <div class="headline">Incidencias</div>
        <span class="grey--text text--lighten-2">Relación de las incidencias notificadas</span>
      </div>
    </v-card-title>

    <v-card-actions>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-btn slot="activator" flat color="orange lighten-2">Notificar nueva incidencia</v-btn>
    
        <v-card>
          <v-card-title>
            <span class="headline">Notificar nueva incidencia</span>
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-select 
                v-model="idPropiedadActiva"
                :items="propiedades"
                item-text="NOMBRE"
                item-value="IDPROPIEDAD">
              </v-select>

              <v-text-field
                v-model="asunto"
                label="Asunto"
                required
              ></v-text-field>
              <v-textarea
                v-model="descripcion"
                label="Descripción de la incidencia"
                required
              ></v-textarea>
              <input 
                style="display: none"
                type="file"
                @change="onFileSelected"
                ref="fileInput">
              <v-btn v-if="!hayAdjunto" @click="$refs.fileInput.click()">Adjuntar fichero</v-btn>
              <v-chip v-model="hayAdjunto" close @input="onCloseChip"> 
              {{ nombreFicheroAdjunto }}
              </v-chip>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="onCancel">Cancelar</v-btn>
            <v-btn color="blue darken-1" flat @click.native="onSave">Guardar</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </v-card-actions>
  
    <v-tabs color="blue-grey" v-model="tabActivo" @change="cargarIncidencias">
      <v-tab class="white--text">Pendientes</v-tab>
      <v-tab class="white--text">Resueltas</v-tab>
    </v-tabs>

    <v-data-table
      :headers="cabecera"
      :items="incidencias"
      :expand="expand"
      item-key="IDINCIDENCIA"
      hide-actions
      class="elevation-1 pa-2"
      no-data-text="Sin datos">

      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
        <td class="text-xs-left">{{ props.item.FECHA_ALTA | moment("DD/MM/YYYY") }}</td>
        <td class="text-xs-left">{{ props.item.DESCRIPCION }}</td>
        <td class="text-xs-left" style="white-space: pre">{{ props.item.DETALLES }}</td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <VerSeguimientoLiquidacion :idIncidencia="props.item.IDINCIDENCIA"></VerSeguimientoLiquidacion>
      </template>

    </v-data-table>
  </v-card>
</template>

<style>
</style>

<script>
  import axios from '@/http-common'

  import { mapState } from 'vuex'
  import { INCIDENCIAS_REQUEST } from '../store/actions/incidencias';
  import { PROPIEDADES_REQUEST, PROPIEDADES_ACTIVATE } from '../store/actions/propiedades'

  import VerSeguimientoLiquidacion from './ver-seguimiento-liquidacion'

  export default {
    components: {
      VerSeguimientoLiquidacion
    },

    name: 'BrwIncidencias',
    
    data: function () {
      return {
          dialog: false,
          expand: false,
          tabActivo: 0,
          snackbar: false,
          snackbarText: '',
          asunto: '',
          descripcion: '',
          prioridad: 2,
          hayAdjunto: false,
          ficheroAdjunto: null,
          nombreFicheroAdjunto: '',
          cabecera: [
              {
                  text: 'Fecha',
                  align: 'left',
                  sortable: false,
                  value: 'FECHA_ALTA'
              },
              {
                  text: 'Descripción',
                  align: 'left',
                  sortable: false,
                  value: 'DESCRIPCION'
              },
              {
                  text: 'Detalles',
                  align: 'left',
                  sortable: false,
                  value: 'DETALLES'
              }
          ]
      }
    },
    created: function () {
      this.cargarIncidencias()
    },
    methods: {
      cargarIncidencias() {
        this.$store.dispatch(INCIDENCIAS_REQUEST, {
          idComunidad: this.$store.state.comunidades.idComunidadActiva,
          estado: (this.tabActivo === 0 ? 0 : 3)
        })
      },
      cargarPropiedades() {
        this.$store.dispatch(PROPIEDADES_REQUEST, {
          idComunidad: this.$store.state.comunidades.idComunidadActiva
        })
      },
      onFileSelected(event) {
        if (event.target.files.length > 0) {
          this.hayAdjunto = true
          this.ficheroAdjunto = event.target.files[0]
          this.nombreFicheroAdjunto = this.ficheroAdjunto.name
        }
      },
      onCancel() {
        this.dialog = false
        this.nombreFicheroAdjunto = ''
        this.ficheroAdjunto = null
        this.hayAdjunto = false
      },
      onSave() {
        this.dialog = false
        
        axios.post('/incidencias', {
          IDPROPIEDAD: this.idPropiedadActiva,
          PRIORIDAD: 1,
          DESCRIPCION: this.asunto,
          DETALLES: this.descripcion,
          ENVIAR_COPIA: 0
        })
        .then((response) => {
          const idIncidencia = response.data.IDINCIDENCIA;

          if (this.ficheroAdjunto) {
            let formData = new FormData();

            formData.append('file', this.ficheroAdjunto);

            axios.post( '/documentos/incidencia/' + idIncidencia,
              formData,
              {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(() => {
              this.snackbarText = 'El registro de la incidencia se ha efectuado correctamente'
              this.snackbar = true
              this.cargarIncidencias()
            })
            .catch(() => {
    
            });
          }
          else {
            this.snackbarText = 'El registro de la incidencia se ha efectuado correctamente'
            this.snackbar = true
            this.cargarIncidencias()  
          }
          
        })
        .catch(() => {
          
        })    
      },
      onCloseChip() {
        this.nombreFicheroAdjunto = ''
        this.ficheroAdjunto = null  
      }
    },
    computed: {
      ...mapState({
        incidencias: state => state.incidencias.incidencias,
        propiedades: state => state.propiedades.propiedades
      }),
      idPropiedadActiva: {
        get() {
          return this.$store.getters.idPropiedadActiva
        },
        set(value) {
          this.$store.dispatch(PROPIEDADES_ACTIVATE, value)
        }
      }
    }
  }
</script>